import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AnalyticsTranscriptViewerState {
  isOpen: boolean;
}

const initialState: AnalyticsTranscriptViewerState = {
  isOpen: false,
};

export const analyticsTranscriptViewerSlice = createSlice({
  name: 'analyticsTranscriptViewer',
  initialState,
  reducers: {
    openTranscriptViewer: (state) => {
      state.isOpen = true;
    },
    closeTranscriptViewer: (state) => {
      state.isOpen = false;
    },
    toggleTranscriptViewer: (state) => {
      state.isOpen = !state.isOpen;
    },
  },
});

export const { openTranscriptViewer, closeTranscriptViewer, toggleTranscriptViewer } = analyticsTranscriptViewerSlice.actions;

export default analyticsTranscriptViewerSlice.reducer; 